import { useMemo } from 'react';
import { SubscriptionPlan } from '@dayetopia/types';
import { BoxState, CartItemType, PadsBoxStackState, PadsBoxState, Prices, ProductCode } from '@contracts';
import { createCartItem } from '@utils/cart';
import useProductPrices from './useProductPrices';

export const useGeneratedCartItem = (
  productCode: ProductCode,
  quantity = 1,
  editable = true,
  type = CartItemType.OneOffPurchase,
  prices?: Prices,
  boxState?: BoxState | PadsBoxState | PadsBoxStackState,
  subscriptionPlans?: SubscriptionPlan[],
  selectedPlan?: SubscriptionPlan
) => {
  const productCodes = useMemo(() => [productCode], [productCode]);
  const productPrices = useProductPrices(productCodes);
  const cartItem = useMemo(() => {
    const price = productPrices[productCode];

    if (price === null || price === undefined || price < 0) {
      return null;
    }

    return createCartItem(productCode, quantity, price, editable, type, prices, boxState, subscriptionPlans, selectedPlan);
  }, [productCode, quantity, editable, type, prices, boxState, subscriptionPlans, selectedPlan, productPrices]);

  return cartItem;
};
